/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RetailerId } from './RetailerId';

export type ProductExclusionUpdate = {
    type?: ProductExclusionUpdate.type;
    value?: string;
    language?: string;
    retailers?: Array<RetailerId>;
    isActive?: boolean;
};

export namespace ProductExclusionUpdate {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

